export const farmExpiration = {
    MONTH: 31,
    TWO_WEEKS: 14,
    TEST: 1000
}